if( undefined == $ ) $ = jQuery;

$(document).ready(function(){
    if( document.location.protocol.indexOf('https') < 0 ) {
        $('.cta.fb').hide();
    }
});

window.fbAsyncInit = function() {
          
    FB.init({
      appId      : '802383433563043',
      cookie     : true,
      xfbml      : true,
      version    : 'v5.0'
    });
      
    FB.AppEvents.logPageView(); 
    
    $('.cta.fb').click(function(){
        FB.login(function(response) {
            
            if(response.status == 'connected') {
                
                var form = $('<form></form>');
    
                form.attr("method", "post");
                form.attr("action", '/fb/login');
            
                $.each(response.authResponse, function(key, value) {
                    var field = $('<input></input>');
            
                    field.attr("type", "hidden");
                    field.attr("name", key);
                    field.attr("value", value);
            
                    form.append(field);
                });
            
                $(document.body).append(form);
                form.submit();
                
            } else {
                console.log(response.status);   
            }            
        }, {scope: 'email,public_profile'}); 
    });
              
};

(function(d, s, id){
 var js, fjs = d.getElementsByTagName(s)[0];
 if (d.getElementById(id)) {return;}
 js = d.createElement(s); js.id = id;
 js.src = "https://connect.facebook.net/en_US/sdk.js";
 fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));